import { z } from 'zod';
import { api } from './api';
import { currentUserSchema, type CurrentUser } from '@/types/schemas';

/** Session tokens arrive as HttpOnly cookies; only the CSRF value is in the body. */
const loginResponseSchema = z.object({
  user: currentUserSchema,
  csrf_token: z.string(),
});

export const authService = {
  login: async (email: string, password: string): Promise<CurrentUser> => {
    const response = await api.post('/auth/login', loginResponseSchema, { email, password });
    return response.user;
  },

  refresh: async (): Promise<CurrentUser> => {
    const response = await api.post('/auth/refresh', loginResponseSchema);
    return response.user;
  },

  /** 204 No Content: the server clears the cookies. */
  logout: (): Promise<void> => api.post('/auth/logout', z.void()),

  me: (signal?: AbortSignal): Promise<CurrentUser> =>
    api.get('/auth/me', currentUserSchema, signal),
};
